import { Component, Input } from '@angular/core';
import { ModalService } from '@shared/services/modal.service';

@Component({
  selector: 'app-learning-image-modal',
  templateUrl: './learning-image-modal.component.html',
  styleUrls: ['./learning-image-modal.component.scss']
})
export class LearningImageModalComponent {
  @Input() imageUrl?: string | null;
  @Input() imageAlt?: string | null;
  @Input() showClose = true;

  constructor(private _modalService: ModalService) {}

  onCloseModal() {
    this._modalService.close();
  }
}
